
import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl, FormattedMessage } from 'react-intl'

import { Timer } from '../../../Core'
import * as phasesActions from '../phases.actions'
import * as firebaseSelectors from '../../../Core/Firebase/firebase.selectors'
import { SESSION_START_TIMER_ID } from '../phases.const'

const cleanTime = (number) => {
  return number < 10 ? '0' + number : number
}

const textTime = (totalSeconds) => {
  const minutes = Math.floor(totalSeconds / 60) % 60
  const hours = Math.floor(totalSeconds / 3600)
  const seconds = Math.floor(totalSeconds % 60)
  return cleanTime(hours) + ':' + cleanTime(minutes) + ':' + cleanTime(seconds)
}

const buttonNewSession = (cb) => (
  <div className="btn--orange" onClick={() => cb()}>
    <span className="icon-rocket"> </span>
    <span>
      <FormattedMessage id={'popups.newSession.accept'} />
    </span>
  </div>
)

const WaitingSessionStartPopup = ({
  waitingSessionSuccess,
  groupData: { session },
  remainingSeconds,
}) => (
  <div className="endsession" style={{ zIndex: 20, backgroundColor: 'white' }}>
    <div className="endsession--title">
      {session === 1 ? (
        <FormattedMessage id={'popups.newGame.title'} />
      ) : (
        <FormattedMessage id={'popups.newSession.title'} />
      )}
    </div>
    <div className="endsession--text">
      {session === 1 ? (
        <FormattedMessage id={'popups.newGame.text'} />
      ) : (
        <FormattedMessage id={'popups.newSession.text'} values={{ session: session - 1 }} />
      )}
    </div>
    <div className="endsession--text">
      {session === 1 ? (
        <FormattedMessage id={'popups.waitingGame.text'} />
      ) : (
        <FormattedMessage id={'popups.waitingSession.text'} />
      )}
    </div>
    <div className="endsession--hour">
      {remainingSeconds > 0 ? textTime(remainingSeconds) : textTime(0)}
    </div>
    {remainingSeconds > 0 ? null : buttonNewSession(waitingSessionSuccess)}
  </div>
)

const mapStateToProps = (state) => ({
  groupData: firebaseSelectors.getGroupData(state),
  remainingSeconds: Timer.selectors.getRemainingSeconds(state, SESSION_START_TIMER_ID),
})

const mapDispatchToProps = (dispatch) => ({
  waitingSessionSuccess: bindActionCreators(phasesActions.waitingSessionSuccess, dispatch),
})

WaitingSessionStartPopup.propTypes = {
  waitingSessionSuccess: PropTypes.func,
  groupData: PropTypes.object,
  remainingSeconds: PropTypes.number,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(WaitingSessionStartPopup))
